import React from 'react';
import ChatSidebar from './ChatSidebar';
import ChatArea from './ChatArea';
import { useTouchLikeInteraction } from '../../hooks/useTouchLikeInteraction';
import './ChatLayout.css';

const ChatLayout = ({
  chats,
  activeChat,
  messages,
  onSelectChat,
  onBackToList,
  newMessage,
  onNewMessageChange,
  onSendMessage,
  onNewChat,
  onNewGroup,
  onRenameChat,
  onDeleteChat,
  loading,
  t,
  inputRef
}) => {
  const isMobile = useTouchLikeInteraction();

  return (
    <div className={`chat-layout ${isMobile ? 'is-mobile' : ''}`}>
      {(!isMobile || !activeChat) && (
        <div className="sidebar-container">
          <ChatSidebar
            chats={chats}
            activeChat={activeChat}
            onSelectChat={onSelectChat}
            onNewChat={onNewChat}
            onNewGroup={onNewGroup}
            onRenameChat={onRenameChat}
            onDeleteChat={onDeleteChat}
            t={t}
          />
        </div>
      )}

      {(!isMobile || activeChat) && (
        <div className="main-area-container">
          <ChatArea
            activeChat={activeChat}
            messages={messages}
            newMessage={newMessage}
            onNewMessageChange={onNewMessageChange}
            onSendMessage={onSendMessage}
            onNewChat={onNewChat}
            onBack={onBackToList}
            loading={loading}
            t={t}
            inputRef={inputRef}
          />
        </div>
      )}
    </div>
  );
};

export default ChatLayout;
